import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'convertForDate'
})
export class ConvertForDatePipe implements PipeTransform {

    transform(date: any, args?: any): any {
        return date && moment(date).isValid() ? moment(date).format('DD/MM/YYYY') : '-';
    }

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/pipe/convert-for-date.pipe.ts